import styled from "styled-components";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useStreamCurrent } from "~/client/hooks";
import Item from "./Item";

const WrapperPartial = styled.div`
  flex: 1;
  flex-shrink: 0;
  width: 100%;
`;

const Content = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    gap: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    width: 100%;
    padding-inline: ${(props) => props.theme.sizes.modalEdge};
    padding-top: ${(props) => props.theme.sizes.edge};
    padding-bottom: calc(${(props) => props.theme.sizes.edge} * 2);
  }
`;

const List = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    gap: calc(${(props) => props.theme.sizes.edge} * 2);
    width: 100%;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.theme.colors.border};
`;

const Description = styled.div`
  & > p {
    ${(props) => props.theme.styles.textParagraph}
    & {
      color: ${(props) => props.theme.colors.gray200};
      line-height: 20pt;
    }
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    ${Content} {
      padding: calc(${(props) => props.theme.sizes.edge} * 2) 0;
      padding-inline: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    }
  }
  ${(props) => props.theme.medias.maxSM} {
    ${Content} {
      padding: calc(${(props) => props.theme.sizes.edge} * 1);
    }
    ${List} {
      gap: calc(${(props) => props.theme.sizes.edge} * 1);
    }
  }
`;

function Body() {
  const { t } = useT();
  const { stream } = useStreamCurrent();

  return (
    <Wrapper>
      <Content>
        <Description>
          <p>{t("structs.streamCircleNote")}</p>
        </Description>
        <Divider />
        <List>
          {stream?.isCanceled ? (
            <Item
              description={_.toSuffix(
                t("tooltips.streamedAmountCanceled"),
                ".",
              )}
              gradient={"red"}
              title={t("structs.streamedAmount")}
            />
          ) : (
            <Item
              description={_.toSuffix(t("tooltips.streamedAmount"), ".")}
              gradient={"secondary"}
              title={t("structs.streamedAmount")}
            />
          )}
          <Item
            description={_.toSuffix(t("tooltips.withdrawnAmount"), ".")}
            gradient={"primary"}
            title={t("structs.withdrawnAmount")}
          />
          <Item
            color={"dark700"}
            description={_.toSuffix(t("tooltips.elapsedTime"), ".")}
            title={t("structs.elapsedTime")}
          />
        </List>
      </Content>
    </Wrapper>
  );
}

export default Body;
